goog.provide('el8.appchart.dialog.smokingStatus');

goog.require('el8.appchart.dialog.selectDate');
goog.require('el8.ptdata.smokingStatuses');
goog.require('el8.service.urls');
goog.require('el8.template.ptdata.smokingStatuses');
goog.require('el8.uiwidget.QuickSelectDialog');


el8.appchart.dialog.smokingStatus = (function() {

    return { 

        show: function(_callbackFn) {

            var currStatus = el8.ptdata.currSmokingStatus ?
                el8.ptdata.currSmokingStatus.getSmokingStatus() : null;

            var availableStatuses = currStatus ? ['No Change ('+ currStatus + ')'] : [];
            availableStatuses.addArray(el8.util.consts.SMOKING_STATUS_TYPES
                .map(function(a) { return a[1]; })
                .filter(function(m) { return m !== currStatus; }));

            var soyMap = el8.ptdata.currSmokingStatus ? el8.ptdata.currSmokingStatus.asSoyMap() : {};
            var msg = el8.template.ptdata.smokingStatuses.dialogSummary(soyMap);

            var that = new el8.uiwidget.QuickSelectDialog({
                title: "Update Patient's Smoking Status",
                width: 405,
                msg: msg,
                callbackFn: function(index) {
                    var noChange = false;
                    var chosenStatus = availableStatuses[index];
                    if (chosenStatus.startswith('No Change')) {
                        noChange = true;
                        chosenStatus = currStatus;
                    }
                    
                    
                    var saveFn = function(asOfDate) {
                        var postDict = { 'smoking_status': chosenStatus };
                        if (asOfDate) {
                            postDict.as_of_date = asOfDate;
                        }
                        $.el8_ajax({
                            url: el8.service.urls.get('smokingStatus'),
                            type: 'POST',
                            data: JSON.stringify(postDict),
                            success: function(data) {
                                el8.appservice.notifier.notify("Patient's smoking status saved.");
                                el8.ptdata.currSmokingStatus = el8.ptdata.smokingStatuses.create(data, true);
                                el8.ptdata.currSmokingStatus.setNoChange(noChange);
                                // Have to notify after assigning currSmokingStatus, because
                                // we use currSmokingStatus to populate
                                el8.ptdata.smokingStatuses.notify();
                                el8.appchart.visitNote.main.addReference({
                                    item: el8.ptdata.currSmokingStatus,
                                    sectionName: 'habits'
                                });
                                that.hide();
                                if (_callbackFn) { _callbackFn(); }
                                el8.ptdata.smokingStatuses.trigger(EVENTS.CREATED, el8.ptdata.currSmokingStatus);
                            }
                        });
                    };

                    if (chosenStatus === 'Never smoker' || chosenStatus === 'Unknown if ever smoked') {
                        saveFn(el8.service.tz.asServerFormatDate(el8.service.tz.today())); // relevant date for non-smokers is always "today"
                    } else {
                        var asOfDate = el8.ptdata.currSmokingStatus ? el8.ptdata.currSmokingStatus.getAsOfDate() : null;
                        var title = 'Began smoking around...';
                        if (chosenStatus === 'Former smoker') {
                            title = 'Stopped smoking around...';
                        }
                        el8.appchart.dialog.selectDate.show({
                            title: title,
                            msg: 'If unknown, leave blank',
                            defaultDate: asOfDate,
                            saveCallbackFn: saveFn
                        });
                    }
                },
                list: availableStatuses
            });

            that.show();
        }

    };

})();

